import request from '@/utils/request'

/** 临时凭证 */
export interface Credentials {
  securityToken: string
  accessKeySecret: string
  accessKeyId: string
  expiration: string
}

/** STS 令牌响应体 */
export interface ResponseToken {
  credentials: Credentials
  cdnUrl: string
  bucketName: string
  preUrl: string
  endpoint: string
}

export interface StsTokenRes {
  code: number
  msg: string
  data: ResponseToken
}

/**
 * 获取阿里云 OSS 临时安全令牌（STS）
 */
export function getAliyunOssPolicy(): Promise<StsTokenRes> {
  return request.get('/ai-api/v1/oss/anon/sts')
}
